import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';

import { KimLhcService } from '@/infra/services/kim-lhc';
import { QUERY_KEYS } from '@/utils/query-keys';

interface CreateKimLhcParams {
	file_id: string;
	workstation_id: string;
	line_id: string;
	sector_id: string;
	company_id: string;
	organization_id: string;
	activity_id: string;
	evaluator_id: string;
	day_duration: number;
	activity_duration: number;
	collect_date: string;
	step: number;
}

const Service = KimLhcService.getInstance();

export const useCreateKimLhcReport = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: CreateKimLhcParams) => await Service.create(params),
		onSuccess: () => {
			message.success(I18n.get('Report created successfully'));
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GET_KIM_LHC] });
		},
		onError: () => {
			message.error(I18n.get('Error creating report'));
		}
	});
};
